import Page from 'modules/Faq'

export default Page

